import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js